import authentication from "@irati/auth"
import {getActiveProducts} from "@irati/products/utils/products"
import businessService from "@irati/identity/services/business"
import userService from "@irati/identity/services/users"
import askNicelyService from "@irati/third-parties/services/AskNicely"
import env from "@irati/utils/env"

import "./askNicely.css"
import {CompanySize} from "../enums"
import {importAskNicely} from "./script"

const getProducts = () => {
  return getActiveProducts().map((item) => item.product)
}

const getUsers = (uuid: string) => {
  return businessService.userCount(uuid).then((userTotal: number) => {
    return userTotal
  })
}

const getCompanySize = (userTotal = 0) => {
  switch (true) {
    case userTotal < 50:
      return CompanySize.SME
    case userTotal < 250:
      return CompanySize.MID_MARKET
    case userTotal >= 250:
      return CompanySize.CORPORATE
    default:
      return null
  }
}

let load: Promise<void> | null = null

const setup = async() => {
  if (load || env.IS_LOCAL) {
    // do not setup on localhost (can't store hashing token on .env file)
    // or if it's already been setup
    return
  }

  const user = authentication.user()
  const now = new Date()
  const activatedAt = new Date(await userService.getActivatedAt(user.uuid))
  const activatedAtThreshold = new Date(await userService.getActivatedAt(user.uuid))
  activatedAtThreshold.setDate(activatedAt.getDate() + 7)

  // do not show survey in the first 7 days, or to admins
  if (now < activatedAtThreshold || authentication.user().isGlobalAdmin) {
    return
  }

  const business = authentication.business()
  const userLocale = authentication.userLocale()
  const userTotal = await getUsers(business.uuid)
  const userRole = user.isGlobalAdmin ? "Admin" : "User"
  const dealPackage = authentication.dealPackage()

  load = importAskNicely().then(() => {
    askNicelyService.getEncodedEmail(user.email).then((hashEmail) => {
      window.askNicelyConversation({
        config: {
          alignment: "center",
          domain_key: "perkbox",
          template_name: "inapp",
          name: user.firstName,
          email: user.email,
          email_hash: hashEmail,
          created: user.metadata?.createdAt
        },
        customData: {
          email: user.email,
          accountId: business.uuid,
          userId: user.uuid,
          tenantLocale: userLocale,
          role: userRole,
          products: getProducts(),
          subDomain: business.subdomain,
          numberOfUsers: userTotal,
          companySize: getCompanySize(userTotal),
          createdAt: user.metadata?.createdAt,
          region: dealPackage?.region
        }
      })
    })
  })
}

export default {setup}
